angular.module('app').controller('ActivitiesPageController',['$scope','$uibModal','$filter','$sce','$q','$window','user','tools','modelstore','parameters','webservice',
                                            function($scope,$uibModal,$filter,$sce,$q,$window,user,tools,modelstore,parameters,webservice) {
  $scope.$window=$window;
  var model=$scope.model;
  var script='public/reservationC';
  $window.scrollTo(0, 0);

  $scope.getFormbuttons = function() {
    var result=[];
    var i,formbutton;
    for(i in model.formbuttons) {
      formbutton=model.formbuttons[i];
      if(formbutton.fca===model.fca && $scope.filterOnDaydurationAndInterval(formbutton)) {
        result.push(formbutton);
      }
    }
    return result;
  };

  $scope.orderByAvailability = function (formbutton) {
    return formbutton.available!==true;
  };

  $scope.filterOnDaydurationAndInterval = function(formbutton) {
    return (formbutton.dayduration==='0' || tools.amountIn(formbutton.dayduration)===((model.multipleDays==='1')?Math.round((model.enddate-model.startdate)/(1000*60*60*24))+1:1)) &&
      (formbutton.fixeddateinterval==='' || formbutton.fixeddateinterval===model.fixedDateIntervalId || formbutton.fixeddateinterval===$scope.fixedDateIntervals[model.fixedDateIntervalId].order);
  };

  $scope.addButtonToShortTermBasket = function(formbutton) {
    $scope.shortTermBasket=$scope.shortTermBasket.concat($filter('orderBy')(tools.join(formbutton,'formbuttoncomponents',model),$scope.sort).map(function(x) {
      return {'formbuttoncomponent':x.id};
    }));
  };

  $scope.filterAvailableFormbuttons = function(formbutton) {
    var result;
    var childFormbuttonrelations=tools.match(model.formbuttonrelations,{'parent':formbutton.id});
    if(tools.getLength(childFormbuttonrelations)>0) {
      result=tools.getLength(childFormbuttonrelations.map(function(formbuttonrelation) {
        return model.formbuttons[formbuttonrelation.child];
      }).filter($scope.filterAvailableFormbuttons))>0;
    } else {
      result=formbutton.available && $scope.filterOnDaydurationAndInterval(formbutton);
    }
    return result;
  };

  $scope.modifyDatesForAccommodation = function() {
    model.multipleDays='1';
    tools.redirect('dates');
  };

  $scope.selectButton = function(formbutton) {
    if(formbutton.available) {
      if(formbutton.pricekey!=='') {
        previousFormbutton=formbutton;
      }
      if(formbutton.clearbasket==='1') {
        $scope.shortTermBasket=[];
      }
      $scope.addButtonToShortTermBasket(formbutton);
      $scope.selectedFormbuttonrelations=tools.match(model.formbuttonrelations,{'parent':formbutton.id}).filter(function(formbuttonrelation) {
        return $scope.filterAvailableFormbuttons(model.formbuttons[formbuttonrelation.child]);
      });
      var selectedFormbuttons=$scope.selectedFormbuttonrelations.map(function(formbuttonrelation) {
        return model.formbuttons[formbuttonrelation.child];
      });
      var availableFormbuttons=selectedFormbuttons.filter($scope.filterAvailableFormbuttons);
      if(availableFormbuttons.length>1) {
        $scope.dismissModal();
        $scope.templates=tools.inverseJoin(selectedFormbuttons,'templates','template',model).reduce(function(acc,cur) {
          acc[cur.id]=tools.clone(cur);
          return acc;
        },{});
        var i,j,template,previousFormbuttoncomponents,previousFormbuttoncomponent,previousDescription,formbuttonsWithThisTemplate,replacedRenderedTemplate;
        if(previousFormbutton!==null) {
          previousFormbuttoncomponents=tools.join(previousFormbutton,'formbuttoncomponents',model);
          if(previousFormbuttoncomponents.length>0) {
            previousFormbuttoncomponent=previousFormbuttoncomponents[0];
            for(i in $scope.templates) {
              template=$scope.templates[i];
              for(j in langs) {
                if(previousFormbuttoncomponent.param1==='AC') {
                  previousDescription=parameters.ACT[previousFormbuttoncomponent.param2.substr(0,3)]['label'+langs[j]];
                } else if(previousFormbuttoncomponent.param1==='HS') {
                  if(previousFormbuttoncomponent.param2.substr(3,3)==='***') {
                    previousDescription=parameters.HTL[previousFormbuttoncomponent.param2.substr(0,3)]['label'+langs[j]];
                  } else {
                    previousDescription=parameters.HSC[previousFormbuttoncomponent.param2]['label'+langs[j]];
                  }
                }
                template['rendered'+langs[j]]=template['rendered'+langs[j]].replace(/%previous%/g,previousDescription);
                template['rendered'+langs[j]]=template['rendered'+langs[j]].replace(/previous/g,previousFormbutton.pricekey);
              }
            }
          }
        }
        for(i in $scope.templates) {
          template=$scope.templates[i];
          formbuttonsWithThisTemplate=tools.match(model.formbuttons,{'template':template.id});
          for(j in langs) {
            replacedRenderedTemplate=tools.replaceAll(model.priceReplace,template['rendered'+langs[j]]);
            if(formbuttonsWithThisTemplate.length===1 && formbuttonsWithThisTemplate[0].singlequantity==='1') {
              replacedRenderedTemplate=replacedRenderedTemplate.replace('%P=PA%',tools.amountOut(model.packPrices[formbuttonsWithThisTemplate[0].id]));
            }
            template['trustedRendered'+langs[j]]=$sce.trustAsHtml(replacedRenderedTemplate);
          }
        }
        $scope.modal=$uibModal.open({
          'templateUrl':'app/views/submenuModal.html',
          'scope':$scope,
          'size':'lg',
          'backdrop':'static',
          'keyboard':false
        });
        $scope.modal.result.then(function(nextFormbutton) {
          $scope.modal=null;
          $scope.selectButton(nextFormbutton);
        },function() {
          $scope.modal=null;
          $scope.shortTermBasket=[];
        });
      } else if(availableFormbuttons.length===1) {
        $scope.selectButton(availableFormbuttons[0]);
      } else {
        previousFormbutton=null;
        $scope.openDetailsModal();
      }
    }
  };

  $scope.editLongTermBasketContent = function(longTermBasketContent) {
    $scope.shortTermBasket=tools.clone(longTermBasketContent);
    $scope.openDetailsModal();
  };

  $scope.trustAsHtml = function() {
    var i,j;
    for(i in model.formbuttoncomponents) {
      for(j in langs) {
        model.formbuttoncomponents[i]['activitieslabel'+langs[j]]=$sce.trustAsHtml(model.formbuttoncomponents[i]['label'+langs[j]]);
      }
    }
  };
  $scope.openDetailsModal = function() {
    var result;
    if($scope.shortTermBasket.length>0) {
      $scope.dismissModal();
      $scope.modal=$uibModal.open({
        'templateUrl':'app/views/detailsModal.html',
        'scope':$scope,
        'size':$scope.isSiteMode?'md':'lg',
        'backdrop':'static',
        'keyboard':false
      });
      result=$scope.modal.result.then(function(response) {
        $scope.modal=null;
        $scope.shortTermBasket=[];
        $scope.updateRecordsFromLongTermBasket(response.shortTermBasket);
        $scope.addRecordsFromShortTermBasket(response.shortTermBasket,response.collections);
        $scope.trustAsHtml();
        return response;
      },function() {
        $scope.modal=null;
        $scope.shortTermBasket=[];
      });
    } else {
      result=$q.reject();
    }
    return result;
  };

  $scope.openBuyParkingModal = function() {
    var result;
    if(model.hrsLists.PRKTIC.available) {
      $scope.shortTermBasket=[{'formbuttoncomponent':'parking'}];
      result=$scope.openDetailsModal().then(function() {
        return $q.resolve();
      });
    } else {
      result=$q.reject();
    }
    return result;
  };

  $scope.openParkingQuestionModal = function() {
    var parkingResult1,activity;
    if(parameters.FFO[$scope.ffo].field5==='1') {
      var activities=[].concat.apply([],model.longTermBasket).filter(function(formbuttoncomponentReference) {
        return formbuttoncomponentReference.formbuttoncomponent in model.formbuttoncomponents && model.formbuttoncomponents[formbuttoncomponentReference.formbuttoncomponent].param1==='AC';
      }).map(function(formbuttoncomponentReference) {
        return model.activities[formbuttoncomponentReference.record];
      });
      var activityNeedsParking=false;
      for(var i in activities) {
        activity=activities[i];
        if(activity.frm in parameters.FRM && parameters.FRM[activity.frm].field11==='1') {
          activityNeedsParking=true;
          break;
        }
      }
      var hotelreservationcategories=[].concat.apply([],model.longTermBasket).filter(function(formbuttoncomponentReference) {
        return formbuttoncomponentReference.formbuttoncomponent in model.formbuttoncomponents && model.formbuttoncomponents[formbuttoncomponentReference.formbuttoncomponent].param1==='HS';
      }).map(function(formbuttoncomponentReference) {
        return model.hotelreservationcategories[formbuttoncomponentReference.record];
      });
      if(activities.length>0 && tools.sum(tools.inverseJoin(tools.join(tools.match(activities,{'frm':'PRKTIC'}),'participants',model),'items','item',model),'quantity')===0.0 &&
          hotelreservationcategories.length===0 && activityNeedsParking) {
        $scope.dismissModal();
        $scope.modal=$uibModal.open({
          'templateUrl':'app/views/parkingQuestionModal.html',
          'scope':$scope,
          'size':'lg',
          'backdrop':'static',
          'keyboard':false
        });
        parkingResult1=$scope.modal.result.then(function(needsParking) {
          var parkingResult2;
          if(needsParking) {
            parkingResult2=$scope.openBuyParkingModal();
          } else {
            parkingResult2=$q.resolve();
          }
          return parkingResult2;
        });
      } else {
        parkingResult1=$q.resolve();
      }
    } else {
      parkingResult1=$q.resolve();
    }
    return parkingResult1;
  };

  $scope.openBuyVoucherModal = function() {
    $scope.shortTermBasket=[{'formbuttoncomponent':'voucher'}];
    $scope.openDetailsModal().then(function(response) {
      var originalFormbuttoncomponentReference=response.shortTermBasket[0];
      var originalProduct=model.products[originalFormbuttoncomponentReference.record];
      originalProduct.isNotShadow=false;
      var originalItem=model.items[originalProduct.item];
      var item,product,formbuttoncomponentReference;
      for(var k=1;k<originalProduct.quantity;k++) {
        item={
          'id':tools.getMinIdMinusOne(tools.toArray(model.items)),
          'visit':'-1',
          'reductionamount':'0',
          'grossunitprice':1,
          'netunitprice':1,
          'quantity':originalItem.quantity
        };
        modelstore.addRecord('items',item,model);
        product={
          'id':tools.getMinIdMinusOne(tools.toArray(model.products)),
          'visit':'-1',
          'item':item.id,
          'prd':'VOU'
        };
        modelstore.addRecord('products',product,model);
        formbuttoncomponentReference={
          'formbuttoncomponent':originalFormbuttoncomponentReference.formbuttoncomponent,
          'record':product.id
        };
        model.longTermBasket.push([formbuttoncomponentReference]);
      }
      model.longTermBasket.push(response.shortTermBasket);
      var params=$scope.createReservationParams([],[],{},false);
      params.visit.campaign='';
      webservice.call('calculatePrices',params,script,model);
    });
  };

  $scope.continue = function() {
    if($scope.isKioskMode) {
      $scope.termsAndConditionsAreAccepted().then(function() {
        $scope.openVoucherModal().then(function(voucherCodes) {
          webservice.exclusiveCall('createToPayCtep',$scope.createReservationParams(voucherCodes,[],{},true),script,model).then(function(response) {
            model.ctepVisit=response.visit;
            if(response.method==='ctep') {
              model.ctepVisitAmount=response.amount;
              tools.redirect('paymentInstructions');
            } else if(response.method==='voucher') {
              tools.redirect('kioskFinished');
            }
          });
        });
      });
    } else if($scope.isSiteMode) {
      if(model.currentStepIndex===tools.getLength($scope.getFilteredFca())) {
        $scope.openParkingQuestionModal().then(function() {
          $scope.redirectToCredentials();
        });
      } else {
        $scope.incrementCurrentStepIndex();
      }
    }
  };

  $scope.loaded.then(function() {
    if(model.currentStepIndex === 0) {
      $scope.incrementCurrentStepIndex();
    } else if(model.currentStepIndex === tools.getLength($scope.getFilteredFca()) + 1) {
      $scope.decrementCurrentStepIndex();
    }
  });

  model.page='activities';
  $scope.shortTermBasket=[];
  var langs=['en','nl','fr'];
  $scope.$on('loaded',$scope.trustAsHtml);
  $scope.trustAsHtml();
  var previousFormbutton=null;
  $scope.breakpointSm=801;
  $scope.dropdownIsOpen=true;
  $scope.itemsPerPage=6;
  $scope.page=1;
}]);
